/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-03-10 17:53:42
 *
 *******************************************************/
//@flow

import _ from 'lodash';

import React, { Component } from 'react';
import { Card, TextStyle, Heading, Icon, Link } from '@shopify/polaris';
import { StarFilledMinor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { connect } from 'react-redux';
import { routes } from 'src/routes';
import history from 'src/routes/history';
import { Carousel } from 'src/components/views/common/carousel';

type Props = {
  tenantApp: Object,
  subscription: Object
};

type ComposedProps = Props & WithI18nProps;
class RecommendedApps extends Component<ComposedProps> {
  render() {
    const { i18n, recommendedApps } = this.props;

    const renderAppsPerRow = [];
    let count = 0;
    while (count < recommendedApps.length) {
      const arr = recommendedApps.slice(count, count + 2);
      renderAppsPerRow.push(arr);
      count += 2;
    }

    const renderListItem = renderAppsPerRow.map((row, rowIndex) => (
      <div className="apps-recommended" key={`row-${rowIndex}`}>
        {row.map((app, appIndex) => (
          <div className="app-detail" key={`app-${appIndex}`}>
            <a className="Polaris-Link" href={app.url} target="_blank" rel="noopener noreferrer">
              <img className="icon" src={app.image.source} alt={app.name} />
              <div className="name">
                <TextStyle variation="strong">{app.name}</TextStyle>
              </div>
            </a>
            <div className="description">{app.detail}</div>
            <div className="rating">
              <Icon source={StarFilledMinor} color="warning" />
              <strong>{app.rate}</strong>
            </div>
            {/* App description*/}
            <div className="plan-info">
              <TextStyle variation="subdued">{app.description}</TextStyle>
            </div>
          </div>
        ))}
      </div>
    ));
    return (
      <div className="BC-RecommendedApps__DashboardV3">
        <Card sectioned>
          <Heading>{i18n.translate('AdminHTML.DashboardV3.RecommendedApps.cardTitle')}</Heading>
          <TextStyle variation="subdued">
            {i18n.translate('AdminHTML.DashboardV3.RecommendedApps.cardDescription', {
              t1: (
                <Link onClick={() => history.push(routes.integration.view())}>
                  {i18n.translate('AdminHTML.DashboardV3.RecommendedApps.cardDescription_t1')}
                </Link>
              )
            })}
          </TextStyle>
          <Carousel items={renderListItem} autoDisplay={true} />
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const tenantApp = _.get(state.oauth, 'tenantApp', {});
  return {
    tenantApp,
    recommendedApps: _.get(state.dashboardV3, 'recommendedApps', []),
    subscription: _.get(state.oauth, 'subscription', {})
  };
};

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(RecommendedApps));
